// extracted by mini-css-extract-plugin
export var border = "_1t-7";
export var brand = "_1t-s";
export var button = "_1t-k";
export var center = "_1t-9";
export var centered = "_1t-5";
export var closeButton = "_1t-b";
export var disabledWrapper = "_1t-l";
export var error = "_1t-o";
export var extraLarge = "_1t-4";
export var extraSmall = "_1t-1";
export var fill = "_1t-h";
export var footer = "_1t-g";
export var footerAction = "_1t-i";
export var footerButtons = "_1t-j";
export var header = "_1t-6";
export var headerWithClose = "_1t-c";
export var icon = "_1t-n";
export var info = "_1t-r";
export var inline = "_1t-8";
export var large = "_1t-3";
export var main = "_1t-d";
export var modal = "_1t-0";
export var neutral = "_1t-t";
export var noPadding = "_1t-f";
export var none = "_1t-u";
export var scrollable = "_1t-e";
export var small = "_1t-2";
export var success = "_1t-q";
export var tight = "_1t-m";
export var titleIcon = "_1t-a";
export var warn = "_1t-p";